<!--
*ngIf="true" hack is required here for router-outlet to work
correctly. Otherwise, it won't register the changes on the
layout and won't update the view.
-->
@if (!isReloading) {
  <div class="h100">
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
}

@if (!termsAccepted) {
  <div class="container-cookies">
    <div class="flex-row flex-row-justify-between grid-gap-50">
      <div>
        {{ 'message.cookiePolicy' | translate }}
      </div>
      <a
        href="javascript:void(0)"
        class="simple-btn simple-btn-md simple-btn-rounded simple-btn-accent simple-btn-shadow"
        (click)="acceptCookies()">
        <span>{{ 'general.ok' | translate }}</span>
      </a>
    </div>
  </div>
}
